module.exports = __webpack_public_path__ + "static/media/cellular-ios-mweb.3c87c6ee.webp";